import React, { useContext, useState, useEffect } from "react";
import storage from "../Assets/js/Global";
import { GlobalContext } from "../Context/GlobalContext";

const Calendar = ({
  onDateChange,
  onClose,
  mode = "default",
  maxDate,
  value,
  highlightedDates = [],
}) => {
  const { translatedLabels } = useContext(GlobalContext);
  const screenLabels = translatedLabels?.common;
  const today = new Date();
  const defaultMaxDate =
    mode === "dob"
      ? new Date(today.getFullYear() - 18, today.getMonth(), today.getDate())
      : mode === "campaign"
        ? null
        : today;

  const storedDate =
    mode === "default" ? storage.get("lastSelectedDate") : null;

  let parsedValueDate = null;

  if (value && mode === "campaign") {
    parsedValueDate = new Date(value);
  }
  const highlightedSet = new Set(highlightedDates);

  if (mode === "dob" && value) {
    const parts = value.split("/");
    if (parts.length === 3) {
      const [yyyy, mm, dd] = parts;
      parsedValueDate = new Date(`${yyyy}-${mm}-${dd}`);
    }
  }

  const initialDate =
    parsedValueDate ||
    (storedDate ? new Date(parseInt(storedDate)) : defaultMaxDate);
  const [currentMonth, setCurrentMonth] = useState(initialDate.getMonth());
  const [currentYear, setCurrentYear] = useState(initialDate.getFullYear());
  const [selectedDate, setSelectedDate] = useState(initialDate.getDate());
  const [selectedHour, setSelectedHour] = useState(initialDate.getHours());
  const [selectedMinute, setSelectedMinute] = useState(
    initialDate.getMinutes(),
  );

  const months = [
    screenLabels?.jan?.label_value || "January",
    screenLabels?.feb?.label_value || "February",
    screenLabels?.march?.label_value || "March",
    screenLabels?.april?.label_value || "April",
    screenLabels?.may?.label_value || "May",
    screenLabels?.june?.label_value || "June",
    screenLabels?.july?.label_value || "July",
    screenLabels?.aug?.label_value || "August",
    screenLabels?.sep?.label_value || "September",
    screenLabels?.oct?.label_value || "October",
    screenLabels?.nov?.label_value || "November",
    screenLabels?.dec?.label_value || "December",
  ];

  const maxYear =
    mode === "dob" ? today.getFullYear() - 18 : today.getFullYear();

  const minYear = mode === "dob" ? 1900 : 2023;

  const years = [];
  for (let y = minYear; y <= maxYear; y++) {
    years.push(y);
  }

  const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
  const firstDay = new Date(currentYear, currentMonth, 1).getDay();

  const daysArray = [];
  for (let i = 0; i < firstDay; i++) daysArray.push(null);
  for (let i = 1; i <= daysInMonth; i++) daysArray.push(i);

  const isPastDate = (day) => {
    if (!day) return false;

    const compareDate = new Date(currentYear, currentMonth, day);
    const todayStart = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate(),
    );

    return compareDate < todayStart;
  };

  const handleDateSelect = (day) => {
    setSelectedDate(day);

    let dateObj = new Date(
      currentYear,
      currentMonth,
      day,
      mode === "campaign" ? selectedHour : 0,
      mode === "campaign" ? selectedMinute : 0,
    );

    if (mode === "default") {
      storage.set("lastSelectedDate", dateObj.getTime());
      onDateChange && onDateChange(dateObj);
    }

    if (mode === "dob") {
      const dd = String(day).padStart(2, "0");
      const mm = String(currentMonth + 1).padStart(2, "0");
      const yyyy = currentYear;
      onDateChange(`${yyyy}/${mm}/${dd}`);
    }

    if (mode === "campaign") {
      onDateChange && onDateChange(dateObj);
    }
  };

  useEffect(() => {
    if (mode === "campaign" && selectedDate) {
      const updatedDate = new Date(
        currentYear,
        currentMonth,
        selectedDate,
        selectedHour,
        selectedMinute,
      );
      onDateChange && onDateChange(updatedDate);
    }
  }, [selectedHour, selectedMinute]);

  const prevMonth = () => {
    if (currentMonth === 0) {
      setCurrentMonth(11);
      setCurrentYear(currentYear - 1);
    } else setCurrentMonth(currentMonth - 1);
  };

  // const nextMonth = () => {
  //   if (
  //     !(
  //       currentYear === today.getFullYear() && currentMonth === today.getMonth()
  //     )
  //   ) {
  //     if (currentMonth === 11) {
  //       setCurrentMonth(0);
  //       setCurrentYear(currentYear + 1);
  //     } else setCurrentMonth(currentMonth + 1);
  //   }
  // };

  const nextMonth = () => {
    if (mode === "campaign") {
      if (currentMonth === 11) {
        setCurrentMonth(0);
        setCurrentYear(currentYear + 1);
      } else {
        setCurrentMonth(currentMonth + 1);
      }
    } else {
      if (
        !(
          currentYear === today.getFullYear() &&
          currentMonth === today.getMonth()
        )
      ) {
        if (currentMonth === 11) {
          setCurrentMonth(0);
          setCurrentYear(currentYear + 1);
        } else setCurrentMonth(currentMonth + 1);
      }
    }
  };

  const isNextDisabled =
    mode !== "campaign" &&
    currentYear === today.getFullYear() &&
    currentMonth === today.getMonth();

  // const isNextDisabled =
  //   currentYear === today.getFullYear() && currentMonth === today.getMonth();

  return (
    <div className="d-flex justify-content-center align-items-center w-100">
      <div className="calendar-container w-100 mb-2">
        <div className="calendar-header mb-0">
          <div className="calender-btn" onClick={prevMonth}>
            <i
              className="fa-solid fa-angle-left"
              style={{ color: "#607D8B" }}
            ></i>
          </div>

          <div className="calendar-selectors">
            <select
              value={currentMonth}
              onChange={(e) => setCurrentMonth(Number(e.target.value))}
              className="py-1 form-select w-100"
            >
              {months.map((m, i) => (
                <option
                  key={m}
                  value={i}
                  // disabled={
                  //   currentYear === today.getFullYear() && i > today.getMonth()
                  // }
                  disabled={
                    mode !== "campaign" &&
                    currentYear === today.getFullYear() &&
                    i > today.getMonth()
                  }
                >
                  {m}
                </option>
              ))}
            </select>
            <select
              value={currentYear}
              onChange={(e) => {
                const newYear = Number(e.target.value);
                setCurrentYear(newYear);
                if (
                  newYear === today.getFullYear() &&
                  currentMonth > today.getMonth()
                ) {
                  setCurrentMonth(today.getMonth());
                }
              }}
              className="py-1 form-select w-100"
            >
              {years.map((y) => (
                <option key={y} value={y}>
                  {y}
                </option>
              ))}
            </select>
          </div>

          <div
            className="calender-btn"
            onClick={nextMonth}
            disabled={isNextDisabled}
            style={{ opacity: isNextDisabled ? 0.4 : 1 }}
          >
            <i
              className="fa-solid fa-chevron-right"
              style={{ color: "#607D8B" }}
            ></i>
          </div>
        </div>

        <div className="calendar-weekdays mt-3">
          {[
            screenLabels?.sun?.label_value || "Sun",
            screenLabels?.mon?.label_value || "Mon",
            screenLabels?.tue?.label_value || "Tue",
            screenLabels?.wed?.label_value || "Wed",
            screenLabels?.thu?.label_value || "Thu",
            screenLabels?.fri?.label_value || "Fri",
            screenLabels?.sat?.label_value || "Sat",
          ].map((d) => (
            <div key={d} className="weekday">
              {d}
            </div>
          ))}
        </div>

        <div className="calendar-days mt-2">
          {daysArray.map((day, idx) => {
            const disabled = mode === "campaign" ? isPastDate(day) : false;

            const dayDateString = day
              ? new Date(currentYear, currentMonth, day).toDateString()
              : "";

            const isSelected =
              day === selectedDate &&
              currentMonth === initialDate.getMonth() &&
              currentYear === initialDate.getFullYear();

            const selectedDateString = new Date(
              currentYear,
              currentMonth,
              selectedDate,
            ).toDateString();

            const isHighlighted =
              highlightedSet.has(dayDateString) && !isSelected;

            return (
              <div
                key={idx}
                className={`day 
        ${isSelected ? "selected" : ""} 
        ${disabled ? "disabled" : ""} 
        ${isHighlighted ? "highlighted" : ""}`}
                onClick={() => !disabled && day && handleDateSelect(day)}
                style={{
                  pointerEvents: disabled ? "none" : "auto",
                  opacity: disabled ? 0.4 : 1,
                }}
              >
                {day && day}
              </div>
            );
          })}
        </div>
        {mode === "campaign" && (
          <>
            <div className="d-flex gap-2 mt-3">
              <select
                className="form-select"
                value={selectedHour}
                onChange={(e) => setSelectedHour(Number(e.target.value))}
              >
                {[...Array(24)].map((_, i) => (
                  <option key={i} value={i}>
                    {String(i).padStart(2, "0")}
                  </option>
                ))}
              </select>

              <select
                className="form-select"
                value={selectedMinute}
                onChange={(e) => setSelectedMinute(Number(e.target.value))}
              >
                {[...Array(60)].map((_, i) => (
                  <option key={i} value={i}>
                    {String(i).padStart(2, "0")}
                  </option>
                ))}
              </select>
            </div>
            <div className="text-end mt-3">
              <button
                type="button"
                className="btn btn-sm btn-primary"
                onClick={() => {
                  onClose && onClose();
                }}
              >
                Done
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Calendar;
